import script from "./ArgonIconPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./ArgonIconPicker.vue?vue&type=script&setup=true&lang=js"

import "./ArgonIconPicker.vue?vue&type=style&index=0&id=2347cf13&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2347cf13"]])

export default __exports__